const destinationBlock = {
  initialize() {
    $('body').on('click', '.destination-block', (event) => {
      const { currentTarget, target } = event;

      if (target.tagName !== 'A') {
        if (this.findLink(currentTarget)) {
          event.preventDefault();
        }
      }
    });
  },

  findLink(block) {
    const $links = $(block).find('a[href*="/redirect/aanbod/"]');

    if (!$links.length) {
      return false;
    }

    const $firstLink = $links.eq(0);

    $firstLink[0].click();

    return true;
  },
};

export default destinationBlock;
